export default __webpack_public_path__ + "static/media/kuber.d5cb20de.jpeg";